import React from "react";

function About() {
  return (
    <main className="bg-gray-50 text-gray-900 min-h-screen">
      <div className="max-w-4xl mx-auto px-8 pt-40 pb-20">
        <h1 className="text-4xl font-bold mb-6 text-center">Our Mission</h1>
        <p className="text-lg text-gray-700 leading-relaxed text-center mb-16">
          About 50% of patients are non-adherent to long term prescriptions. Missing one dose could change a life in an instant. With a simple, universal design and scalable technology, we're redefining how people interact with their prescriptions. Any person has a chance to make their own pill bottle "smart" which just a few taps.
        </p>
        
        <h2 className="text-4xl font-bold mb-12 text-center">Our Vision</h2>
        <div className="space-y-8">
          {/* Section 1 */}
          <div className="flex items-center gap-6">
            <div className="flex-shrink-0 w-24 h-24 rounded-full bg-blue-900 border-4 border-blue-300 flex items-center justify-center">
              <span className="text-white text-3xl font-bold">50%</span>
            </div>
            <div className="bg-blue-100 rounded-lg p-6 flex-1">
              <p className="text-gray-800 text-lg leading-relaxed">
                In the United States, approximately 30%-50% of patients do not take their prescribed medication as recommended.
              </p>
            </div>
          </div>

          {/* Section 2 */}
          <div className="flex items-center gap-6">
            <div className="flex-shrink-0 w-24 h-24 rounded-full bg-blue-900 border-4 border-blue-300 flex items-center justify-center">
              <span className="text-white text-3xl font-bold">125k</span>
            </div>
            <div className="bg-blue-100 rounded-lg p-6 flex-1">
              <p className="text-gray-800 text-lg leading-relaxed">
                Additionally, non-adherence is linked to up to 25% of all hospitalisations and around 125,000 deaths annually.
              </p>
            </div>
          </div>

          {/* Section 3 */}
          <div className="flex items-center gap-6">
            <div className="flex-shrink-0 w-24 h-24 rounded-full bg-blue-900 border-4 border-blue-300 flex items-center justify-center">
              <svg className="w-14 h-14 text-white" fill="currentColor" viewBox="0 0 24 24">
                {/* Pill bottle cap */}
                <rect x="9" y="2" width="6" height="3" rx="1"/>
                {/* Pill bottle body */}
                <rect x="7" y="5" width="10" height="14" rx="1"/>
                {/* Label area */}
                <rect x="9" y="7" width="6" height="8" fill="none" stroke="currentColor" strokeWidth="0.5"/>
              </svg>
            </div>
            <div className="bg-blue-100 rounded-lg p-6 flex-1">
              <p className="text-gray-800 text-lg leading-relaxed">
                Pill Pal envisions a world where no one's health is compromised by a missed dose.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <footer className="text-center py-6 text-gray-500 border-t">
        © {new Date().getFullYear()} Pill Pal. All rights reserved.
      </footer>
    </main>
  );
}

export default About;

